<template>
  <div class="ms-resize-screen" ref="screen">
    <div class="master-section-horizontal pdg-16" :style="['height: ' + heightResize + '%']"
          :class="[{'point-event-none': isHandlerDragging}, {'flex-column': isFlex}]">
      <slot name="content-master"></slot>
    </div>
    <div class="detail-section-horizontal pdg-16" :class="[{'point-event-none': isHandlerDragging}, {'mtop-12': heightResize > 6}]" v-show="isShowDetailSection">
      <div class="divider-section">
        <div class="slide-line" @mouseup="resizeOffDetail" @mousedown="resizeOnDetail">
          <div class="resize-icon"></div>
          <div class="resize-icon second"></div>
        </div>
        <div class="toggle-above-screen" :class="{expand: !toggleAbove}" :tabindex="-1" @click="collapseHandler" v-tooltip="toggleAbove ? 'Mở rộng' : 'Thu nhỏ'"></div>
      </div>
      <slot name="content-item"></slot>
    </div>
  </div>
  
</template>
<script>
import { defineComponent, onMounted, reactive, ref, getCurrentInstance, computed, watch } from 'vue';
export default {
  name: 'msResizeScreen',
  props: {
    isFlex:{
      default: true,
      type: Boolean
    },
    /**
     * Có show phần chi tiết và co kéo không
     */
    isShowDetailSection:{
      default: true,
      type: Boolean
    },
  },
  setup(props) {
    const { proxy } = getCurrentInstance();
    const isHandlerDragging = ref(false);
    const heightResize = ref(50.5);

    if(!props.isShowDetailSection){
      heightResize.value = 100;
    }
    const maxSize = 98;
    const toggleAbove = ref(true);

    /**
     * Ngừng có kéo
     * NXCHIEN 02.06.2023
     */
    const resizeOffDetail = () => {
      document.removeEventListener('mousemove', mousemoveDetail);
      document.removeEventListener('mouseup', resizeOffDetail);
      isHandlerDragging.value = false;
      
    };

    /**
     * Di chuyển co kéo grid
     * @param {*} e
     * @returns
     * NXCHIEN 02.06.2023
     */
    const mousemoveDetail = e => {
      if (!isHandlerDragging.value) {
        return;
      }

      let $item = proxy.$refs["screen"];
      // chiều cao của ms-resize-screen (tính từ trên cùng màn hình đến đỉnh của component)
      let heightRef = typeof $item.getBoundingClientRect == 'function' ? $item.getBoundingClientRect().y + 70 : 0; // 70 là độ dài từ thanh địa chỉ url lên trên cùng màn hình
      let footer = 50;
      let val = ((e.screenY - heightRef) * 100) / (screen.availHeight - heightRef - footer);
      heightResize.value = val <= maxSize ? val : maxSize;

      if (screen.availHeight <= 200) {
        heightResize.value = 0;
      }
    };

    /**
     * Bắt đầu kéo thả
     * NXCHIEN 02.06.2023
     */
    const resizeOnDetail = () => {
      isHandlerDragging.value = true;
      document.addEventListener('mousemove', mousemoveDetail);
      document.addEventListener('mouseup', resizeOffDetail);
    };

    /**
     * Collapse Detail trên danh sách
     * @returns
     * NXCHIEN 05.06.2023
     */
    function collapseHandler() {
      isHandlerDragging.value = false;
      toggleAbove.value = !toggleAbove.value;
      if (heightResize.value == maxSize) {
        heightResize.value = 50.5;
        return;
      }

      if (heightResize.value < maxSize) {
        heightResize.value = maxSize;
        return;
      }
    }

    return {
      isHandlerDragging,
      resizeOffDetail,
      resizeOnDetail,
      collapseHandler,
      toggleAbove,
      heightResize,

    };
  },
};
</script>
<style lang="scss" scoped>
.ms-resize-screen{
  .mtop-12{
    margin-top: 12px;
  }
  .pdg-16{
    padding: 0 16px;
  }
  .detail-section-horizontal {
    display: flex;
    flex-direction: column;
    position: relative;
    transition: all 0.1s ease;
    height: 0;
    flex: 1;
    margin-bottom: 8px;
    background-color: $white;
    z-index: 10;
    .content-ttc {
      position: relative;
      background-color: white;
      height: 100%;
      margin-top: 3px;
    }
    .divider-section {
      position: absolute;
      width: 100%;
      height: 16px;
      left: 0;
      top: -12px;
      background-color: $white;
      z-index: 10;
      .slide-line {
        height: 10px;
        position: absolute;
        width: 100%;
        top: 3px;
        background: 0 0;
        border-radius: 2px;
        background: #f4f5f8;
        &:hover {
          cursor: row-resize;
          .resize-icon {
            visibility: visible;
          }
        }
        &:active {
          .resize-icon {
            visibility: visible;
          }
        }
        .resize-icon {
          width: 30px;
          height: 8px;
          border: 1px solid #a8a8a8;
          border-left: none;
          border-right: none;
          position: absolute;
          top: 2px;
          right: calc(66% - 15px);
          visibility: hidden;
          &:before {
            content: '';
            height: 1px;
            width: 12px;
            background: #a8a8a8;
            position: absolute;
            top: 50%;
            left: 9px;
          }
        }
        .second {
          right: calc(33% + 15px);
        }
      }

      .collapse-btn {
        position: absolute;
        left: calc(50% - 30px);
        width: 48px;
        height: 13px;
        background: #d4d7dc;
        margin-top: 2px;
        border: 1px solid #d4d7dc;
        border-radius: 4px;
        display: flex;
        justify-content: center;
        z-index: 9;
      }

      .toggle-above-screen {
        cursor: pointer;
        outline: none;
        top: 3px;
        right: 50%;
        width: 56px;
        height: 10px;
        border: none;
        background-color: $primary;
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        border-radius: 4px;
        &:hover {
          background-color: #0790fc;
        }
        &:before {
          content: '';
          position: absolute;
          background: transparent url($ms-image-sprites) no-repeat;
          height: 10px;
          width: 20px;
          top: 0;
          left: 19px;
          background-position: -194px -79px !important;
        }
        &.expand {
          &:before {
            content: '';
            position: absolute;
            background: transparent url($ms-image-sprites) no-repeat;
            height: 10px;
            width: 20px;
            top: 0;
            left: 19px;
            background-position: -194px -55px !important;
          }
        }
      }
    }
  }
}


</style>
